// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + ".v64." + "4bd33da5c30834f1c50a" + ".js";
};